import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import PropTypes from "prop-types";

const ApprovalModal = ({ show, onHide, onConfirm, action, item }) => {
    const [comments, setComments] = useState("");
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        setLoading(true);
        try {
            await onConfirm(comments);
            setComments("");
            onHide();
        } catch (error) {
            console.error("Error in approval:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setComments("");
        onHide();
    };

    const getButtonText = () => {
        return 'Approve';
    };

    const getTitle = () => {
        return 'Approve Assignment';
    };

    const getMessage = () => {
        return `Are you sure you want to approve this assignment?`;
    };

    return (
        <Modal show={show} onHide={handleClose} centered className="modalDeleteWrapper">
            <Modal.Header closeButton>
                <Modal.Title>{getTitle()}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>{getMessage()}</p>
                {item && (
                    <div className="mb-3">
                        <strong>Assignment Details:</strong>
                        <div className="mt-2">
                            <div><strong>From:</strong> {item.oldCompanySellerName}</div>
                            <div><strong>To:</strong> {item.companySellerName}</div>
                            <div><strong>Carrier:</strong> {item.carrierName}</div>
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose} disabled={loading}>
                    Cancel
                </Button>
                <Button
                    variant={action === 'approve' ? 'success' : 'danger'}
                    onClick={handleConfirm}
                    disabled={loading}
                >
                    {loading ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
                            {'Approving...'}
                        </>
                    ) : (
                        getButtonText()
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

ApprovalModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    action: PropTypes.oneOf(['approve']).isRequired,
    item: PropTypes.shape({
        assignmentId: PropTypes.string,
        fromCompany: PropTypes.string,
        fromSeller: PropTypes.string,
        toCompany: PropTypes.string,
        toSeller: PropTypes.string,
        carrierConnectId: PropTypes.string,
        carrierName: PropTypes.string,
        oldCompanySellerName: PropTypes.string,
        companySellerName: PropTypes.string,
    })
};

export default ApprovalModal;